import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=2bca41c2&"
import script from "./BookingStatus.vue?vue&type=script&lang=js&"
export * from "./BookingStatus.vue?vue&type=script&lang=js&"
import style0 from "./BookingStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports